import { render, staticRenderFns } from "./TransitionType.vue?vue&type=template&id=193149aa&scoped=true"
import script from "./TransitionType.vue?vue&type=script&lang=js"
export * from "./TransitionType.vue?vue&type=script&lang=js"
import style0 from "./TransitionType.vue?vue&type=style&index=0&id=193149aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193149aa",
  null
  
)

export default component.exports